import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SingleInvoice from "./components/single-invoice";
import { api_url } from "../../constant";

const InvoicePage = () => {
    const { id } = useParams();
    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInvoice = async () => {
            try {
                const response = await fetch(`${api_url}/invoices/${id}`, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                if (!response.ok) {
                    throw new Error("Failed to fetch invoice");
                }
                const data = await response.json();
                // Mapping backend response to match frontend fields
                const formattedInvoice = {
                    invoiceId: data.invoiceId,
                    issuedDate: data.issuedDate,
                    seller: data.seller,
                    buyer: data.buyer,
                    cropName: data.cropName,
                    quantity: data.quantity ?? "غير متوفر",
                    amount: data.amount,
                    deliveryDate: data.deliveryDate,
                    notes: data.notes,
                    status: data.status,
                    unit: data.unit,
                    deliveryPlace: data.deliveryPlace,
                    deliveryResponsibility: data.deliveryResponsibility,
                    paymentTerms: data.paymentTerms,
                    negotiation: data.negotiation,
                };
                setInvoice(formattedInvoice);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchInvoice();
    }, [id]);

    if (loading) return <p className="text-center text-lg">جارٍ تحميل الفاتورة...</p>;
    if (error) return <p className="text-center text-red-500">حدث خطأ: {error}</p>;

    return (
        <div className="container mx-auto p-4">
            <SingleInvoice invoice={invoice} />
        </div>
    );
};

export default InvoicePage;